<template>
  <nav class="navbar navbar-expand-lg navbar-light fixed-top" id="mainNav">
    <div class="container px-4 px-lg-5">
      <a href="/">
        <img
          src="@/assets/img/ironwood-logo.svg"
          alt="Ironwood Logo"
          class="mx-2"
          style="
            padding-bottom: 5px;
            padding-right: 1.5em;
            height: 2em;
            filter: invert(79%) sepia(38%) saturate(4886%) hue-rotate(2deg)
              brightness(107%) contrast(95%);
          "
        />
      </a>
      <a class="navbar-brand" href="/">ironwood flutes</a>
      <button
        class="navbar-toggler navbar-toggler-right"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarResponsive"
        aria-controls="navbarResponsive"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <font-awesome-icon icon="fa-solid fa-bars"></font-awesome-icon>
      </button>
      <div class="collapse navbar-collapse" id="navbarResponsive">
        <ul class="navbar-nav ms-auto">
          <li class="nav-item">
            <a class="nav-link" href="/flutes">flutes</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="/headjoints">headjoints</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="/whistles">whistles</a>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/custom">custom</router-link>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="/#about">about</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="/#contact">contact</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script lang="ts">
export default {
  name: "NavigationSectionComponent",
};
</script>
